
import React, { useEffect, useState, useContext, useMemo } from "react";
import { StyledTableTimesheet } from "../../styled-components/StyledTableTimesheet.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { useTable, useSortBy, useFilters, useColumnOrder } from "react-table";
import IntlCurrencyInput from "react-intl-currency-input";
import { Link } from "react-router-dom";
import Flex from '@react-css/flex';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IconTable } from "../../svg";
import { getTimeline } from '../../services/timeline';

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

const deafultOrderColumns = [
    "ac",
    "sigla",
    "timeSheetSigla",
    "lider",
    "cliente.clienteNome",
    "statusTimesheet",
    "segurado.seguradoNome",
    "workflow",
    "tipoTimesheet",
    "horasTimeSheet",
    "valorTimesheet"
];

export const TableTimesheet = (props) => {
    const {
        listaTS,
        loadingData,
        openObservacoesTimesheet,
        openModalASolicitarEsclarecimento,
        openModalTimesheetTimeline,
        isFromProjetoInterno
    } = props;
    var [listTsTable, setListTsTable] = useState([]);
    var [columns, setColumns] = useState([]);

    const ColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const StartStringColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;
        return (
            <input
                value={filterValue || ""}
                onChange={e => {
                    setFilter(e.target.value || undefined);
                }}
                placeholder={`Filtrar`}
                className={`width-${inputFilterClass}`}
            />
        );
    };

    const removerAcentosEEspeciais = (texto) => {
        if (!texto) {
            return "";
        }

        return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    }

    const startsWith = (rows, ids, filterValue) => {
        rows = rows.filter((row) => {
            return ids.some((id) => {
                const rowValue = row.values[id];

                const texto1Limpo = removerAcentosEEspeciais(rowValue);
                const texto2Limpo = removerAcentosEEspeciais(filterValue);

                return texto1Limpo.startsWith(texto2Limpo);
            });
        });
        return rows;
    }

    const MoneyColumnFilter = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            <IntlCurrencyInput
                currency="BRL"
                config={currencyConfig}
                defaultValue={filterValue || ""}
                onChange={(_event, value, _maskedValue) => {
                    setFilter(value || undefined);
                }}
                style={{
                    width: `${inputFilterClass}px`,
                    marginRight: '10px',
                    textAlign: "right"
                }}
            />
        );
    };

    const MoneyRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[0] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [value ? value : undefined, old[1]])
                    }}
                    style={{
                        width: '100px',
                        marginRight: '10px',
                        textAlign: "right"
                    }}
                />
                <div className="pt-2">Até</div>
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    defaultValue={filterValue[1] || ''}
                    onChange={(_event, value, _maskedValue) => {
                        setFilter((old = []) => [old[0], value ? value : undefined])
                    }}
                    style={{
                        width: '100px',
                        marginLeft: '10px',
                        textAlign: "right"
                    }}
                />
            </div>
        )
    }

    const NumberRangeColumnFilter = ({ column: { filterValue = [], preFilteredRows, setFilter, id }, }) => {
        const [min, max] = useMemo(() => {
            let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
            preFilteredRows.forEach(row => {
                min = Math.min(row.values[id], min)
                max = Math.max(row.values[id], max)
            })
            return [min, max]
        }, [id, preFilteredRows])

        return (
            <div
                style={{
                    display: 'flex',
                }}
            >
                <input
                    value={filterValue[0] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
                    }}
                    placeholder={`Min`}
                    style={{ width: '80px', marginRight: '10px' }}
                />
                <div className="pt-2">Até</div>
                <input
                    value={filterValue[1] || ''}
                    type="number"
                    onChange={e => {
                        const val = e.target.value
                        setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
                    }}
                    placeholder={`Max`}
                    style={{ width: '80px', marginLeft: '10px' }}
                />
            </div>
        )
    }

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';
        }

        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    const convertDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return 0;
        }

        const newValue = value.replace('R$', '').replace(/\./g, '').replace(',', '.');
        return isNaN(newValue) ? 0 : parseFloat(newValue);
    }

    const filterAcoes = ({ column }) => {
        const { filterValue, setFilter, filter, inputFilterClass } = column;

        return (
            null
        );
    };

    function handleGetTimeline(idTimesheet) {
        getTimeline(idTimesheet)
            .then(data => {
                openModalTimesheetTimeline(data);
                // aqui você usa o `data` como precisar
            })
            .catch(err => {
                console.error("Erro ao buscar timeline:", err);
            });
    }

    const getActions = (props) => {
        const row = props.row.original
        let dadosUsuario = JSON.parse(localStorage.getItem("PROFILE_DATA_SISCOPE"));

        return (
            <Flex.Item className="flex-column-right header-items">
                {/* <a className="menu-link hover">
                    <i className="fa fa-calendar" onClick={() => openModalTimesheetTimeline(props.cell.row.original)}>
                    </i>
                </a> */}
                <a className="menu-link hover">
                    <i
                        className="fa fa-calendar"
                        onClick={() => handleGetTimeline(props.cell.row.original.idTimesheet)}
                    ></i>
                </a>
                {
                    row?.actions?.notificacaoEsclarecimento && (
                        <a className="menu-link hover" onClick={() => openModalASolicitarEsclarecimento(row)} title="Esclarecimento">
                            <i className={row.pendenteDeEsclarecimento ? (row.idusuarioUltimaMsgEscalrecimento == dadosUsuario.idUsuario ? "fa fa-list-ol possui-comentarios" : "fa fa-list-ol possui-comentarios resposta-pendente") : "fa fa-list-ol"}></i>
                        </a>
                    )
                }

                <a className="menu-link hover" onClick={() => openObservacoesTimesheet(row.idTimesheet)} title="Observação">
                    <i className={row.quantidadeComentarios > 0 ? "fa fa-comments-o possui-comentarios" : "fa fa-comments-o"}></i>
                </a>
                {
                    isFromProjetoInterno ?
                    <Link className="menu-link" to={{ pathname: "/timesheetpidetalhespage/", hash: row.idTimesheet }} title="Detalhes do Projeto Interno">
                        <i className="fa fa-search"></i>
                    </Link>
                    :
                    <Link className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: row.idTimesheet }} title="Detalhes do Timesheet">
                        <i className="fa fa-search"></i>
                    </Link>
                }
                
            </Flex.Item>
        );

    };

    const reduzirString = (texto, limite) => {
        if (texto && texto?.length > limite) {
            return texto.slice(0, limite) + '...';
        } else {
            return texto;
        }
    }

    const getSegurado = (row) => {

        const text = row?.segurado?.seguradoNome

        return (
            <span title={text}>{reduzirString(text, 25)}</span>
        );

    };

    const getCutText = (text, size) => {

        if (!text) {
            return '';
        }


        return (
            <span title={text}>{reduzirString(text, size)}</span>
        );

    };

    const getEtapa = (row) => {
        const text = row?.workflow
        return (
            <span title={text}>{reduzirString(text, 25)}</span>
        );

    };

    columns = useMemo(
        () => [

            {
                Header: "Ações",
                accessor: "ac",
                className: "text-left",
                inputFilterClass: "60",
                sortDescFirst: true,
                Cell: (props) => {
                    return getActions(props);
                },
                Filter: filterAcoes,
            },
            {
                Header: "Laudo",
                accessor: "sigla",
                className: "text-center",
                sortDescFirst: true,
                inputFilterClass: "60",
                Cell: (props) => {
                    return (props.row.original.actions.indicacao ? <span className="indicacaoCheck" >{props.row.original.sigla}</span> : <>{props.row.original.sigla}</>)
                }
            },
            {
                Header: "TS",
                accessor: "timeSheetSigla",
                className: "text-center",
                classNameFooter: "text-center legend-value",
                inputFilterClass: "60",
                sortDescFirst: true,
            },
            {
                Header: "Vida Útil",
                accessor: "vidaUtil",
                className: "text-center",
                inputFilterClass: "60",
                sortDescFirst: true,
                Cell: (props) => {
                    return (<span className="badge bg-lightblue" >{props.row.original.vidaUtil}</span>)
                }
            },
            // {
            //     Header: "Data",
            //     accessor: "dataTimesheet",
            //     className: "text-center",
            //     inputFilterClass: "80",
            //     sortType: (a, b) => {
            //         const parseDMY = s => {
            //             let [d, m, y] = s.split(/\D/);
            //             return new Date(y, m - 1, d);
            //         };
            //         return new Date(parseDMY(a.values.dataTimesheet)) - new Date(parseDMY(b.values.dataTimesheet));
            //     }
            // },
            {
                Header: "Lider",
                accessor: "lider",
                className: "text-left",
                inputFilterClass: "120",
                sortDescFirst: true,
                Cell: (props) => {
                    return getCutText(props?.row?.original?.lider, 20);
                },
            },
            {
                Header: "Seguradora",
                accessor: "cliente.clienteNome",
                className: "text-left",
                inputFilterClass: "100",
                sortDescFirst: true,
                Cell: (props) => {
                    return getCutText(props?.row?.original?.cliente?.clienteNome, 30);
                },
            },
            {
                Header: "Status",
                accessor: "statusTimesheet",
                className: "text-center",
                inputFilterClass: "90",
                sortDescFirst: true,
            },
            {
                Header: "Segurado",
                accessor: "segurado.seguradoNome",
                className: "text-left",
                inputFilterClass: "140",
                sortDescFirst: true,
                Cell: (props) => {
                    return getSegurado(props?.row?.original);
                },
            },
            {
                Header: "Etapa da aprovação",
                accessor: "workflow",
                className: "text-left",
                inputFilterClass: "140",
                sortDescFirst: true,
                Cell: (props) => {
                    return getEtapa(props?.row?.original);
                },
                Filter: StartStringColumnFilter,
                filter: startsWith
            },
            {
                Header: "Tipo TS",
                accessor: "tipoTimesheet",
                className: "text-center",
                inputFilterClass: "80",
                sortDescFirst: true,
            },
            {
                Header: "Horas",
                accessor: "horasTimeSheet",
                className: "text-right",
                classNameFooter: "text-right legend-value",
                inputFilterClass: "50",
                sortDescFirst: true,
                Cell: (props) => {
                    return <div>{formatDecimal(props.cell.value)}</div>;
                },
                Footer: info => {
                    const total = React.useMemo(
                        () =>

                            info.rows.reduce((sum, row) => convertDecimal(row.original.horasTimeSheet) + sum, 0),
                        [info.rows]
                    )
                    return <> {formatDecimal(total)}</>
                },

            },
            {
                Header: "Valor ",
                accessor: "valorTimesheet",
                className: "text-right",
                classNameFooter: "text-right legend-value",
                filter: 'money',
                width: '50px',
                inputFilterClass: "90",
                sortDescFirst: true,
                Cell: (props) => {
                    return <div>{props?.row?.original?.valorTotalDesconto > 0 ? "*" : ""} {props.cell.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</div>;
                },
                Footer: info => {
                    const total = React.useMemo(
                        () =>
                            info.rows.reduce((sum, row) => convertDecimal(row.original.valorTimesheet) + sum, 0),
                        [info.rows]
                    )
                    return <> {total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</>
                },
                Filter: MoneyColumnFilter,
            },
        ],
        []
    );

    const getClassRow = (row) => {
        return row.statusTimesheet === 'Reanálise' ?
            ' revisaoCard' : row?.pendenteDeEsclarecimento ? ' esclarecimentoCard'
                : (row?.actions?.notificacaoAtividade || row?.actions?.notificacaoGrupoAtividade) ? ' notificacaoCard'
                    : (row?.atividadesProbono > 0 ? ' probonoCard' : '')
    };

    const filterTypes = {
        text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id];
                return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
            });
        }
    };
    const defaultColumn = { Filter: ColumnFilter };
    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        footerGroups,
        rows, // rows for the table based on the data passed
        prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
        setColumnOrder
    } = useTable({ columns, data: listTsTable, defaultColumn, filterTypes }, useFilters, useSortBy, useColumnOrder);

    const getHeadTableAccessor = (columnsHead) => {
        let columns = [];
        columnsHead.forEach((column) => {
            columns.push(column.accessor);
        });

        return columns;
    };


    const handleDragEnd = (result) => {
        if (!result.destination) return;
        try {
            const reorderedColumns = getLastConfigOrderColumns();
            const [removed] = reorderedColumns.splice(result.source.index, 1);
            reorderedColumns.splice(result.destination.index, 0, removed);
            setColumnOrder(reorderedColumns);
            saveLastColumns(reorderedColumns);

        } catch (error) {
            console.log(error);
        }

    };

    const saveLastColumns = (columns) => {

        if (columns?.length === 0) {
            return;
        }

        localStorage.setItem('columnsTs', JSON.stringify(columns));
    };


    const getLastConfigOrderColumns = () => {
        const columnsN = localStorage.getItem('columnsTs');
        if (columnsN) {
            var columnsInStorage = JSON.parse(columnsN)
            if(columnsInStorage.length != deafultOrderColumns.length) {
                columnsInStorage.splice(3, 0, "vidaUtil")
                saveLastColumns(columnsInStorage);
            }
            return columnsInStorage;
        }
        return deafultOrderColumns;
    }

    const loadingLastConfigCollumns = () => {

        const columnsN = getLastConfigOrderColumns();
        if (columnsN) {
            setColumnOrder(columnsN);
        }
    };


    const resetColuns = () => {

        setColumnOrder(deafultOrderColumns);
        saveLastColumns(deafultOrderColumns);

    }


    useEffect(() => {
        setTimeout(() => {
            loadingLastConfigCollumns();
        }, 1000);
    }, []);


    useEffect(() => {


        listTsTable = [];
        setListTsTable([]);

        if (listaTS?.data?.itens?.length > 0) {
            listTsTable = listaTS?.data?.itens
            setListTsTable(listaTS?.data?.itens);
        }

    }, [listaTS]);



    return (
        <StyledTableTimesheet>
            <div className="timesheet">
                {rows && rows.length > 0 ? <button className="btn btn-xs pull-right collumResetBtn" onClick={resetColuns} title="reset configuração personalizada das colunas"><IconTable /></button> : null}
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="columns-droppable-ts" direction="horizontal">
                        {(provided) => (
                            <StyledTablePage>
                                <div
                                    className="table-container"

                                >
                                    <table
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        {...getTableProps()}
                                        className="table table-bordered table-width table-sm"
                                    >
                                        <thead>
                                            {headerGroups.map((headerGroup) => (
                                                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                                                    {headerGroup.headers.map((column, index) => (
                                                        <Draggable
                                                            key={'TsTabH' + index}
                                                            draggableId={'TsDraggableId' + index}
                                                            index={index}
                                                        >
                                                            {(provided) => (
                                                                <th
                                                                    {...column.getHeaderProps(
                                                                        column.getSortByToggleProps()
                                                                    )}
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className={`${column?.classnameHeader} align-middle text-center`}
                                                                >
                                                                    {column.render("Header")}
                                                                    <span style={{ marginLeft: "3px" }}>
                                                                        {column.isSorted ? (
                                                                            column.isSortedDesc ? (
                                                                                <svg
                                                                                    width="12px"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    viewBox="0 0 320 512"
                                                                                >
                                                                                    <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
                                                                                </svg>
                                                                            ) : (
                                                                                <svg
                                                                                    width="12px"
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    viewBox="0 0 320 512"
                                                                                >
                                                                                    <path d="M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z" />
                                                                                </svg>
                                                                            )
                                                                        ) : null}
                                                                    </span>
                                                                    <div>
                                                                        {column.canFilter
                                                                            ? column.render("Filter")
                                                                            : null}
                                                                    </div>
                                                                </th>
                                                            )}
                                                        </Draggable>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>
                                        <tbody {...getTableBodyProps()}>
                                            {rows && rows.length > 0 ? rows.map((row, i) => {
                                                prepareRow(row);
                                                return (
                                                    <tr {...row.getRowProps()} className={`table-data-info `} key={'tsTr' + i}>

                                                        {

                                                            row.cells.map((cell, i) => {
                                                                return (
                                                                    <td  {...cell.getCellProps()} className={`${cell.column.className} ${getClassRow(row?.original)}`}>
                                                                        <div className={`${(row?.cells[i].column?.tag && 'badge badge-secondary')}` + ` ${row?.cells[i].column?.className}`}>
                                                                            {cell.render("Cell")}
                                                                        </div>
                                                                    </td>
                                                                );
                                                            })}
                                                    </tr>
                                                );
                                            }) :
                                                (
                                                    !loadingData && <tr key={'tsTr' + 999999}>
                                                        <td colSpan={columns[0]?.columns?.length ?? 12} className="text-center">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Esse Timesheet não foi encontrado. Por favor, adicione um novo ou verifique se o sinistro já foi cadastrado.
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                        <tfoot>
                                            {rows && rows.length > 0 ? footerGroups.map((footerGroup) => (
                                                <tr {...footerGroup.getFooterGroupProps()} >
                                                    {footerGroup.headers.map((cell, i) => {
                                                        if (cell.accessor) {
                                                            return (
                                                                <td className={`${cell?.classNameFooter}`} >{cell.Footer && cell.render('Footer')}</td>
                                                            );
                                                        }

                                                    })}
                                                </tr>
                                            )) : null}
                                        </tfoot>
                                    </table>
                                    {provided.placeholder}
                                </div>
                            </StyledTablePage>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </StyledTableTimesheet>
    );



};
